module.exports = __webpack_public_path__ + "img/A1990.cf92dfd9.png";